import { isNil } from 'lodash';

import { FormSubmission, getUserDisplayNameByUserId } from '@pwp-common';

import { ChartTableRow, CreateChartTableRowsInput } from './interfaces';

export const createChartTableRows = ({
  formSubmissions,
  formVersions,
  forms,
  allUserDataMap,
  timezone,
}: CreateChartTableRowsInput): ChartTableRow[] => {
  const submissionsByVersionId = new Map<string, FormSubmission[]>();

  for (const submission of formSubmissions) {
    const versionId = submission.getFormVersionId();
    const existing = submissionsByVersionId.get(versionId) ?? [];
    existing.push(submission);
    submissionsByVersionId.set(versionId, existing);
  }

  return Array.from(submissionsByVersionId.entries())
    .map(([formVersionId, submissions]): ChartTableRow | null => {
      const formVersion = formVersions.get(formVersionId);

      if (isNil(formVersion)) {
        console.error('createChartTableRows: FormVersion is undefined for id', formVersionId);
        return null;
      }

      const formId = formVersion.getFormId();
      const form = forms.get(formId);

      if (isNil(form)) {
        console.error('createChartTableRows: Form is undefined for id', formId);
        return null;
      }

      const isLatestVersion = form.getActiveVersionId() === formVersionId;

      return {
        id: formVersionId,
        name: form.getDisplayName(),
        isLatestVersion,
        createdBy: getUserDisplayNameByUserId(allUserDataMap, formVersion.getCreatedByUserId()),
        createTime: formVersion.getCreateTime()?.tz(timezone),
        submissionCount: submissions.length,
        formId,
        formVersionId,
        formSchema: formVersion.getFormSchema(),
        submissionData: submissions.map((submission) => JSON.parse(submission.getValue())),
      };
    })
    .filter((row): row is ChartTableRow => !isNil(row));
};
